import React, { Component } from 'react';
import ossUpload from '../../util/ossUpload';

export default class extends Component {
  constructor(props) {
    super(props);
    ossUpload.init();
  }
  counter = 0;
  onChange = (e) => {
    const fileList = e.target.files;
    for (let i = 0, len = fileList.length; i < len; i++) {
      this.startUpload({
        uid: new Date().getTime() + this.counter++ + '',
        file: fileList[i],
        status: 'uploading',
        progress: 0,
        name: fileList[i].name,
        width: -1,
        height: -1
      });
    }
  };
  startUpload = (fileInfo) => {
    const { onChange, onProgress } = this.props;
    onChange && onChange(fileInfo);
    ossUpload.upload(
      fileInfo.file,
      (event, url) => {
        onChange &&
        console.log('done:'+ fileInfo.uid)
          onChange(
            Object.assign(fileInfo, {
              status: 'done',
              progress: 100,
              url
            })
          );
      },
      () => {
        onChange &&
        onChange(
          Object.assign(fileInfo, {
            status: 'error',
          })
        );
      },
      (event, url) => {
        const {loaded, total} = event
        if(loaded !== total){
          onProgress && onProgress(
            Object.assign(fileInfo, {
              progress: parseInt(loaded/total*100)
            })
          );
        }else{
          console.log('progress done:'+ fileInfo.uid)
        }
        // else{
        //     console.log('onProgress')
        //     onProgress && onProgress(
        //       Object.assign(fileInfo, {
        //         status: 'done',
        //         progress: 100,
        //         url
        //       })
        //     );
        // }
      }
    );
  };
  onClick() {
    console.log(this.refs['upload'].files)
    this.refs['upload'].click();
  }
  render() {
    return (
      <input
        ref="upload"
        style={{
          display: 'none',
        }}
        multiple="multiple"
        onChange={this.onChange}
        // capture="camera"
        type="file"
        accept="image/*"
      />
    );
  }
}
